import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconWebProtectionProps } from './IconWebProtection.types'
import * as Styled from './styles/IconWebProtection.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWebProtection: FC<IconWebProtectionProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWebProtectionProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconWebProtectionProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M21.512 4.914c0 12.059-7.774 15.899-9.274 16.563a.591.591 0 0 1-.488 0c-1.5-.665-9.266-4.5-9.266-16.563 0-1.777 3.399 1.238 9.079-2.316a.823.823 0 0 1 .874 0c2.227 1.394 4.106 1.91 5.563 1.937h3.512Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M7.855 15.45c.473-2.223 2.153-3.864 4.145-3.864 1.992 0 3.672 1.64 4.145 3.863m-1.731-6.515A2.416 2.416 0 0 1 12 11.352a2.416 2.416 0 0 1 0-4.832h2.414Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconWebProtection
